import {ChangeEvent, FC, useCallback, useRef} from "react";
import Button, {ButtonProps} from "./Button.tsx";

type UploadButtonProps = ButtonProps & {
    accept: string
    onFileSelected: (file: File) => void
}

const UploadButton: FC<UploadButtonProps> = ({onFileSelected, children, accept, ...rest}) => {
    const fileInputRef = useRef<HTMLInputElement | null>(null);

    const handleAdd = useCallback(() => {
        fileInputRef.current?.click();
    }, [])

    const handleChangeFileInput = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length == 1) {
            onFileSelected(event.target.files[0])
        }
        if (fileInputRef.current) {
            fileInputRef.current!.value = ""
        }
    }, [onFileSelected])

    return (
        <Button onClick={handleAdd} {...rest}>
            {children}
            <input
                ref={fileInputRef}
                type="file"
                onChange={handleChangeFileInput}
                accept={accept}
                style={{display: 'none'}}
            />
        </Button>
    )
}


export default UploadButton
